import { render } from "./UserChat.vue?vue&type=template&id=0f8b07ee&scoped=true"
import script from "./UserChat.vue?vue&type=script&lang=js"
export * from "./UserChat.vue?vue&type=script&lang=js"

import "./UserChat.vue?vue&type=style&index=0&id=0f8b07ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8b07ee"]])

export default __exports__